import React, { useEffect, useState } from "react";
import { FaRegFileAlt } from "react-icons/fa";
import ContainerFlex from "../ContainerFlex";
import Bullet from "../bullet";

import * as St from "./styles";

export interface ICheckbox {
  bulletColor?: string;
  message?: string;
  value?: boolean;
  readOnly?: boolean;
  onChangeStatus?: Function;
  onStatus?: Function;
  invoiceIcon?: boolean;
  readonly?: boolean;
  auto?: boolean;
  end?: boolean;
}

const Checkbox: React.FC<ICheckbox> = ({
  bulletColor = null,
  value = false,
  invoiceIcon = false,
  message,
  onChangeStatus,
  onStatus,
  readonly,
  auto = true,
  end = false,
}) => {
  const [status, setStatus] = useState(value);

  useEffect(() => {
    setStatus(value);
  }, [value]);

  const onChange = () => {
    const newStatus = !status;

    if (onChangeStatus) onChangeStatus(newStatus);

    if (onStatus) onStatus(!newStatus);

    if (!readonly) setStatus(newStatus);
  };

  return (
    <ContainerFlex row center end>
      <St.CheckboxContainer onClick={onChange}>
        <St.HiddenCheckbox checked={status} readOnly />
        <St.StyledCheckbox checked={auto ? status : value}>
          <St.Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </St.Icon>
        </St.StyledCheckbox>
      </St.CheckboxContainer>

      <St.StCheckboxMessage>
        {invoiceIcon ? (
          <St.InvoiceIcon>
            <FaRegFileAlt />
          </St.InvoiceIcon>
        ) : (
          ""
        )}
        {message || ""}
      </St.StCheckboxMessage>

      {bulletColor && (
        <Bullet
          style={{ marginLeft: "auto" }}
          color={bulletColor}
          margin={8}
          marginTop={14}
          marginBottom={22}
        />
      )}
    </ContainerFlex>
  );
};

export default Checkbox;
